var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-scrollable",
      attrs: {
        "data-scrollable": "true",
        "data-height": "380",
        "data-mobile-height": "300"
      }
    },
    [
      _c("div", { staticClass: "m-timeline-2" }, [
        _c(
          "div",
          {
            staticClass:
              "m-timeline-2__items  m--padding-top-25 m--padding-bottom-30"
          },
          _vm._l(_vm.timelineArr, function(timeline) {
            return _c(
              "div",
              { staticClass: "m-timeline-2__item m--margin-bottom-50" },
              [
                _c("span", { staticClass: "m-timeline-2__item-time" }, [
                  _vm._v(_vm._s(timeline.date)),
                  _c("br"),
                  _c("span", { staticClass: "small" }, [
                    _vm._v(_vm._s(timeline.time) + " Uhr"),
                    _c("br"),
                    _vm._v("KW" + _vm._s(timeline.kw))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "m-timeline-2__item-cricle" }, [
                  _c("i", {
                    staticClass: "fa fa-genderless",
                    class: timeline.cssClass
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "m-timeline-2__item-text  m--padding-top-5" },
                  [
                    _c("div", { staticClass: "mb-2" }, [
                      _c(
                        "span",
                        {
                          staticClass: "m--font-bold",
                          class: timeline.cssClassHeadline
                        },
                        [_vm._v(_vm._s(timeline.title))]
                      ),
                      _vm._v(" "),
                      timeline.title2 != ""
                        ? _c("span", [_vm._v(_vm._s(timeline.title2))])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    timeline.type == 1
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-3" }, [
                            _vm._v(
                              "Anfrage: " + _vm._s(timeline.typeArr.inquiryId)
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-3" }, [
                            _vm._v("KW: " + _vm._s(timeline.typeArr.kw))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-3" }, [
                            _vm._v("Bilder: " + _vm._s(timeline.typeArr.images))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-3" }, [
                            _vm._v("Umsatz: " + _vm._s(timeline.typeArr.sum))
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    timeline.type == 2
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-3" }, [
                            _vm._v("Bilder: " + _vm._s(timeline.typeArr.images))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-3" }, [
                            _vm._v("Umsatz: " + _vm._s(timeline.typeArr.sum))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-3" }, [
                            _vm._v("Kosten: " + _vm._s(timeline.typeArr.kosten))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-3" }, [
                            _vm._v("Gewinn: "),
                            timeline.typeArr.gewinn > 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "m--font-bold m--font-success"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(timeline.typeArr.gewinnFormat)
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "m--font-bold m--font-danger"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(timeline.typeArr.gewinnFormat)
                                    )
                                  ]
                                )
                          ])
                        ])
                      : _vm._e()
                  ]
                )
              ]
            )
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }